import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { parseJwt } from '../plugins/utils/Authorization.js'

const SUPER_ADMIN_PROFILE = 'superAdminCoexya_1hVUyc'
//const SUPER_ADMIN_PROFILE = 'dev'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:notFound',
      component: () => import('../views/NotFoundView.vue')
    },
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/configure',
      name: 'configure',
      component: () => import('../views/ConfigureView.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('../views/ForgotPasswordView.vue')
    }
  ]
})

router.beforeEach(async (to, from) => {
  let isAuthenticated = false
  
  let profile = null
  const token = localStorage.getItem('token')
  if (token) { 
    isAuthenticated = true
    const parsedToken = parseJwt(token)
    profile = parsedToken.profile
  }
  if (!isAuthenticated && to.name !== 'login' && to.name !== 'forgot-password') return { name: 'login' }
  if (isAuthenticated && (to.name === 'login' || to.name === 'forgot-password' || (to.name === 'configure' && profile !== SUPER_ADMIN_PROFILE))) return { name: 'home' }  
})

export default router
